import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

// Which marketing page the "Get Started" CTA lives on. Kept out of `location` so position reads cleanly across pages.
export enum MARKETING_PAGE {
	LANDING = 'landing',
	FREE_ATS = 'free_ats',
	AI_SCREENING = 'ai_screening',
	COMPARISON = 'comparison',
	ALTERNATIVES = 'alternatives',
	BEST_FREE_ATS = 'best_free_ats',
	CHANGELOG = 'changelog',
	MCP = 'mcp',
	AI_ATS = 'ai_ats',
	SWITCH = 'switch',
	ATS_WITH_MCP = 'ats_with_mcp',
	SCREEN_APPLICATION_EMAILS = 'screen_application_emails',
	SCREEN_GOOGLE_FORMS = 'screen_google_forms',
}

// Where on the page the CTA sits.
export type GetStartedLocation = 'hero' | 'header' | 'footer' | 'pricing';

const PAGE_TO_FEATURE: Record<MARKETING_PAGE, MIXPANEL_APP_FEATURES> = {
	[MARKETING_PAGE.LANDING]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
	[MARKETING_PAGE.FREE_ATS]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
	[MARKETING_PAGE.AI_SCREENING]: MIXPANEL_APP_FEATURES.AI_SCREENING_PAGE,
	[MARKETING_PAGE.COMPARISON]: MIXPANEL_APP_FEATURES.COMPARE_PAGE,
	[MARKETING_PAGE.ALTERNATIVES]: MIXPANEL_APP_FEATURES.COMPARE_PAGE,
	[MARKETING_PAGE.BEST_FREE_ATS]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
	[MARKETING_PAGE.CHANGELOG]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
	[MARKETING_PAGE.MCP]: MIXPANEL_APP_FEATURES.MCP_PAGE,
	[MARKETING_PAGE.AI_ATS]: MIXPANEL_APP_FEATURES.AI_ATS_PAGE,
	[MARKETING_PAGE.SWITCH]: MIXPANEL_APP_FEATURES.SWITCH_PAGE,
	[MARKETING_PAGE.ATS_WITH_MCP]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
	[MARKETING_PAGE.SCREEN_APPLICATION_EMAILS]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
	[MARKETING_PAGE.SCREEN_GOOGLE_FORMS]: MIXPANEL_APP_FEATURES.LANDING_PAGE,
};

// Single entry point for the "Get Started" CTA: landing fires its own event, every other page shares one keyed by `page`.
export function trackGetStartedClicked(page: MARKETING_PAGE, location: GetStartedLocation) {
	if (page === MARKETING_PAGE.LANDING) {
		emitMixpanelEvent(mixpanelEvents.CLICKED_LANDING_PAGE_GET_STARTED, {
			feature: MIXPANEL_APP_FEATURES.LANDING_PAGE,
			location,
		});
		return;
	}

	emitMixpanelEvent(mixpanelEvents.CLICKED_GET_STARTED, {
		feature: PAGE_TO_FEATURE[page],
		page,
		location,
	});
}
